import BaseAPI from "../api";

const path: string = "/examination-calendar-student";

export class ExaminationCalendarStudentApi extends BaseAPI {
  static list(query: any,id:any): Promise<any> {
    return this.api.get(`${path}/${id}/list`, {
      params: { ...query },
    });
  }
  static post(body: any): Promise<any> {
    return this.api.post(`${path}`, body);
  }
  static upload(body: any): Promise<any> {
    return this.api.post(`${path}/upload-files`, body, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
  static patch(body: any, id: any): Promise<any> {
    return this.api.patch(`${path}/${id}`, body);
  }
  static approve(body: any, id: any): Promise<any> {
    return this.api.patch(`${path}/${id}/approve-or-reject-student`, body);
  }
  static approveDetail(body: any, id: any): Promise<any> {
    return this.api.patch(`${path}/${id}/approve-detail-student`, body);
  }
  static findById(id: any): Promise<any> {
    return this.api.get(`${path}/${id}/find-one`);
  }
  static findByIdApprove(id: any): Promise<any> {
    return this.api.get(`${path}/${id}/find-one-approve-detail`);
  }
  static delete(id: any): Promise<any> {
    return this.api.delete(`${path}/${id}`);
  }
  static download(id: any): Promise<any> {
    return this.api.get(`${path}/${id}/download`,{ responseType: 'arraybuffer' });
  }
}
